import type { StaticInfo } from '@/comp/StationControlCenter/types/universal-device.types';
import type { Device } from '@/store/Station/constants';

export type StaticInfoItem = {
  key: string;
  label: string;
  value: string;
  unit: string;
};

type DeviceMeta = {
  attributes?: Record<string, unknown>;
};

const isMissingValue = (value: unknown) => value === undefined || value === null || value === '';

export const getStaticInfoValue = (
  deviceFromStationStore: Device,
  deviceFromDevicesStore: DeviceMeta | undefined,
  key: string,
): string => {
  const stationRecord = deviceFromStationStore as unknown as Record<string, unknown>;
  const stationValue = stationRecord[key];
  if (!isMissingValue(stationValue)) return String(stationValue);

  const attributesValue = deviceFromDevicesStore?.attributes?.[key];
  if (!isMissingValue(attributesValue)) return String(attributesValue);

  return 'N/A';
};

export const getStaticInfoItems = (
  deviceFromStationStore: Device,
  deviceFromDevicesStore: DeviceMeta | undefined,
  staticInfo: StaticInfo[],
): StaticInfoItem[] => {
  const entries = staticInfo.length ? staticInfo : [];
  
  return entries.map(({ value: key, unit }) => ({
    key,
    label: key,
    value: getStaticInfoValue(deviceFromStationStore, deviceFromDevicesStore, key),
    unit: unit === 'Text' ? '' : unit ?? '',
  }));
};